import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxImageCompressService } from 'ngx-image-compress';
import { LabReqViewComponent } from './lab-req-view/lab-req-view.component';
import { LabReqBaseModule } from './lab-req-base/lab-req-base.module';
import {
  LabReqAbComponent,
  LabReqBcComponent,
  LabReqQcComponent,
  LabReqSkComponent
} from '..';
import { LabReqNfComponent } from '../lab-req-nf/lab-req-nf.component';
@NgModule({
  declarations: [LabReqViewComponent],
  providers: [NgxImageCompressService],
  imports: [
    CommonModule,
    LabReqBaseModule,
    LabReqBcComponent,
    LabReqQcComponent,
    LabReqAbComponent,
    LabReqSkComponent,
    LabReqNfComponent
  ],
  exports: [
    CommonModule,
    LabReqBaseModule,
    LabReqBcComponent,
    LabReqQcComponent,
    LabReqSkComponent,
    LabReqAbComponent,
    LabReqNfComponent,
    LabReqViewComponent
  ]
})
export class LabReqViewModule {}
